import { createFileRoute } from '@tanstack/react-router';

import { getContactQueryOptions } from '@/_pages/contacts/api-service';
import Loading from '@/_pages/contacts/marketing-campaigns/loading';

export const Route = createFileRoute('/_private/contacts/_template/$id/marketing-campaigns')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getContactQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'Marketing Campaigns',
    isFullWidth: true,
    tabKey: 'contacts/marketing-campaigns',
  },
  pendingComponent: Loading,
});
